import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { document } from 'ionicons/icons'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getDocumentScannerSelector } from '../selectors/documentScanner.selector'

const ScanDocumentButton: React.FC = () => {
  const history = useHistory()
  const { disableScanButton } = useSelector(getDocumentScannerSelector)

  const onScanDocumentClick = () => {
    history.push(AppRouterConstants.DOCUMENT_SCANNER_ROUTE)
  }

  return (
    <IonButton
      data-testid='ScanDocument'
      className='scan-drivers-license-button'
      expand='block'
      fill='clear'
      onClick={onScanDocumentClick}
      disabled={disableScanButton}
      color='primary-alt'>
      <IonIcon icon={document} size='large' />
      Scan Document
    </IonButton>
  )
}

export default ScanDocumentButton
